import z from "zod";

const CorrectText = z.object({
	id: z.literal("correct"),
	original_text: z
		.string()
		.describe("The portion of text that is grammatically correct and well-written")
});

const MistakeText = z.object({
	id: z.literal("mistake"),
	original_text: z.string().describe("The incorrect text portion that contains mistakes"),
	corrected_text: z
		.string()
		.describe("The corrected version of the text with proper grammar/vocabulary"),
	description: z
		.string()
		.describe("Clear explanation of what mistakes were found and why the correction is better")
});

export const MistakeAnalysis = z.object({
	analysis_parts: z
		.array(z.union([CorrectText, MistakeText]))
		.describe(
			"Break down the entire text into segments - each segment is either correct or contains mistakes. Cover the entire original text without gaps or overlaps."
		)
});

export type IMistakeAnalysis = z.infer<typeof MistakeAnalysis>;
export type IMistakeAnalysisPartsUnion = z.infer<typeof MistakeText> | z.infer<typeof CorrectText>;
